import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";

const Chips = ({ text, small }) => {
  return (
    <Box
      background="#9CCDFB"
      borderRadius="4px"
      b="none"
      padding="4px"
      w="fit-content"
      margin="0 8px"
      h="fit-content"
    >
      <Text fontSize={small ? "12px" : "14px"} margin="0">
        {text}
      </Text>
    </Box>
  );
};

export default Chips;
